
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 72","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.32 6.968h34.813v8.129a1.16 1.16 0 001.16 1.161h8.124v9.29h2.32V15.097c0-.322-.13-.612-.34-.822l-9.28-9.287a1.159 1.159 0 00-.823-.343H6.963V2.323h44.095V27.87h2.321V1.161A1.16 1.16 0 0052.22 0H5.802a1.16 1.16 0 00-1.16 1.161v3.484H1.16A1.16 1.16 0 000 5.806V70.84A1.16 1.16 0 001.16 72h39.455v-2.323H2.32V6.967zM39.455 8.61l5.322 5.325h-5.322V8.61z","fill":"#4788C6","fill-rule":"nonzero"}}),_c('path',{attrs:{"fill-rule":"nonzero","d":"M4.966 23.586h29.793v2.483H4.966zM4.966 27.31h29.793v2.483H4.966zM4.966 18.62h29.793v2.483H4.966zM4.966 32.276h23.586v2.483H4.966zM4.966 37.241h23.586v2.483H4.966zM4.966 42.207h23.586v2.483H4.966zM4.966 55.862h23.586v2.483H4.966zM4.966 60.828h23.586v2.482H4.966zM4.966 64.552h23.586v2.482H4.966zM6.207 8.69H8.69v2.482H6.207zM9.931 8.69h2.483v2.482H9.93zM14.897 8.69h2.482v2.482h-2.482zM19.862 8.69H34.76v2.482H19.862z"}}),_c('g',{attrs:{"stroke":"#4788C6","stroke-width":"2"}},[_c('path',{attrs:{"d":"M33.276 35.759H62.31v27.793H33.276z"}}),_c('path',{attrs:{"stroke-linecap":"square","d":"M38.894 40.984L56.276 57.92M56.236 40.984L38.854 57.92"}})])])])
          )
        }
      }
    